import { ChevronDown, LogOut, User as UserIcon } from 'lucide-react'
import { useRef, useState } from 'react'

import { useCurrentUser, useLogout } from '../api/auth'
import { useClickOutside } from '../lib/useClickOutside'
import { ProfileDialog } from './ProfileDialog'

export function UserMenu() {
  const { data: user } = useCurrentUser()
  const logout = useLogout()
  const [open, setOpen] = useState(false)
  const [profileOpen, setProfileOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useClickOutside(ref, () => setOpen(false), open)

  return (
    <div className="user-menu" ref={ref}>
      <button
        type="button"
        className="user-menu__trigger"
        onClick={() => setOpen((current) => !current)}
        aria-expanded={open}
        aria-label="Menú de usuario"
      >
        <span className="user-menu__avatar" aria-hidden="true">
          {user?.email?.[0]?.toUpperCase()}
        </span>
        <ChevronDown size={14} className={`user-menu__chevron${open ? ' is-open' : ''}`} />
      </button>

      <div className={`dropdown user-menu__dropdown${open ? ' open' : ''}`} role="menu">
        <div className="user-menu__email mono">{user?.email}</div>
        <button
          type="button"
          className="user-menu__item"
          role="menuitem"
          onClick={() => {
            setOpen(false)
            setProfileOpen(true)
          }}
        >
          <UserIcon size={14} />
          Mi perfil
        </button>
        <button
          type="button"
          className="user-menu__item"
          role="menuitem"
          onClick={() => logout.mutate()}
          disabled={logout.isPending}
        >
          <LogOut size={14} />
          Cerrar sesión
        </button>
      </div>

      {profileOpen && <ProfileDialog onClose={() => setProfileOpen(false)} />}
    </div>
  )
}
